/**
 * DashboardGrid — DS Layout
 * Grille CSS configurable pour dashboards (KPI cards, charts, widgets)
 */

import styles from './DashboardGrid.module.css';

interface DashboardGridProps {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function DashboardGrid({ children, columns = 3, gap = 'md', className = '' }: DashboardGridProps) {
  return (
    <div
      className={`${styles.grid} ${styles[`cols${columns}`]} ${styles[`gap${gap}`]} ${className}`}
    >
      {children}
    </div>
  );
}
